import React, { useCallback } from "react";
import {
  ModalProps,
  createUseModal,
  useModal,
} from "@imminently/react/context/modals";
import {
  Dialog, DialogTitle,
} from "@imminently/react/ui/core/dialog";
import { Text } from "@imminently/react/ui/core/text";
import { DialogContent, IconButton } from "@mui/material";
import { Icon } from "@/components/Icon";
import { scrollable } from "@/components/scrollable";

type ZoomModalProps = {
  component: React.ReactNode;
  title?: string;
}

const ZoomContentModal = ({ props }: ModalProps<ZoomModalProps>) => {
  const { component, title } = props;
  const { popModal: close } = useModal();

  const scaleComponent = useCallback((contentElement: HTMLDivElement | null) => {
    if (!contentElement) return contentElement;
    // const scaleX = contentElement.parentElement ? (contentElement.parentElement.offsetWidth / contentElement.parentElement.scrollWidth)
    //   : ( contentElement.offsetWidth / contentElement.scrollWidth );

    const scaleY = contentElement.parentElement ? (contentElement.parentElement.offsetHeight / contentElement.parentElement.scrollHeight)
      : (contentElement.offsetHeight / contentElement.scrollHeight);

    contentElement.style.transform = `scale(${scaleY})`;
    contentElement.style.transformOrigin = "top";
    return contentElement;
  }, []);



  const closeModal = () => {
    close();
  };

  return (
    <Dialog open fullScreen>
      <DialogTitle>
        {title && <Text variant="h4">{title}</Text>}
        <IconButton onClick={closeModal}>
          <Icon icon="close" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={scrollable} style={{ overflow: "hidden" }}>
        <div ref={(node) => {
          scaleComponent(node);
        }} style={{ marginBottom: "40px" }}>
          {component}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const useZoomContentModal = createUseModal(ZoomContentModal);
